import React, { useState } from 'react';
import { Subscription } from '../../../../types/subscription';
import { Bot } from 'grts-utils/types/Bot';
import { FaChevronRight } from 'react-icons/fa';
import { colors } from '../../../../colors';
import './index.css';
import ManageBalance from './Balance';
import ManageState from './State';
import ManageCalculations from './Calculations';

interface Props {
  subscription: Subscription;
  bot: Bot | undefined;
}

export enum ManageActions {
  Balance = 'balances',
  State = 'states',
  Calculations = 'Calculations',
}

const Manage = (props: Props) => {
  const { subscription, bot } = props;

  const [activeAction, setActiveAction] = useState<ManageActions>(
    ManageActions.Balance,
  );

  return (
    <div
      style={{
        display: 'flex',
        marginRight: -30,
        paddingRight: 15,
        flex: 1,
      }}
    >
      <ActionsList
        activeAction={activeAction}
        setActiveAction={setActiveAction}
      />
      <div
        style={{
          overflowY: 'scroll',
          width: '100%',
        }}
      >
        {activeAction === ManageActions.Balance && (
          <ManageBalance
            subscription={subscription}
            maxDecimals={bot?.complexParams?.maxDecimals}
          />
        )}
        {activeAction === ManageActions.State && (
          <ManageState
            subscription={subscription}
            maxDecimals={bot?.complexParams?.maxDecimals}
          />
        )}
        {activeAction === ManageActions.Calculations && (
          <ManageCalculations bot={bot} />
        )}
      </div>
    </div>
  );
};

export default Manage;

const ActionsList = ({
  activeAction,
  setActiveAction,
}: {
  activeAction: ManageActions;
  setActiveAction: React.Dispatch<React.SetStateAction<ManageActions>>;
}) => {
  return (
    <div
      style={{
        paddingLeft: '10px',
        borderRight: '1px rgb(69, 69, 69) solid',
        paddingTop: '10px',
      }}
    >
      <ActionsListItem
        action={ManageActions.Balance}
        setActiveAction={setActiveAction}
        isActiveAction={activeAction === ManageActions.Balance}
      />
      <ActionsListItem
        action={ManageActions.State}
        setActiveAction={setActiveAction}
        isActiveAction={activeAction === ManageActions.State}
      />
      <ActionsListItem
        action={ManageActions.Calculations}
        setActiveAction={setActiveAction}
        isActiveAction={activeAction === ManageActions.Calculations}
      />
    </div>
  );
};

const ActionsListItem = ({
  action,
  isActiveAction,
  setActiveAction,
}: {
  action: ManageActions;
  isActiveAction: boolean;
  setActiveAction: React.Dispatch<React.SetStateAction<ManageActions>>;
}) => {
  return (
    <div
      style={{
        position: 'relative',
        textTransform: 'capitalize',
        color: isActiveAction ? 'white' : 'gray',
        fontWeight: isActiveAction ? 'bold' : '400',
        cursor: !isActiveAction ? 'pointer' : 'default',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingRight: '75px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      className="actions-list-item"
      onClick={() => setActiveAction(action)}
    >
      {action}
      {isActiveAction && (
        <FaChevronRight
          color={colors.white}
          size={18}
          className={'chevron'}
          style={{ position: 'absolute', right: 0 }}
        />
      )}
    </div>
  );
};
